import { useState, useCallback, useRef } from 'react';
import toast from 'react-hot-toast';

export function useCRUD(service, entityName = 'Item') {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving] = useState(false);

  // FIX: از ref استفاده می‌کنیم تا stale closure نداشته باشیم
  const pageRef = useRef(page);
  const searchRef = useRef(search);
  pageRef.current = page;
  searchRef.current = search;

  const fetchData = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const res = await service.getAll({
        page: pageRef.current,
        limit: 20,
        search: searchRef.current,
        ...params
      });
      setData(res.data.data || []);
      setTotal(res.data.pagination?.total || 0);
    } catch (e) {
      const msg = e.response?.data?.message || `Failed to load ${entityName}s`;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  }, [service, entityName]);

  const handleSave = async (formData) => {
    setSaving(true);
    try {
      if (editItem?._id) {
        await service.update(editItem._id, formData);
        toast.success(`${entityName} updated successfully`);
      } else {
        await service.create(formData);
        toast.success(`${entityName} created successfully`);
      }
      setModalOpen(false);
      setEditItem(null);
      // کمی صبر کن بعد refresh کن
      setTimeout(() => fetchData(), 100);
    } catch (e) {
      const msg = e.response?.data?.message || `Failed to save ${entityName}`;
      toast.error(msg);
      console.error('Save error:', e.response?.data || e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(`Are you sure you want to delete this ${entityName}?`)) return;
    try {
      await service.delete(id);
      toast.success(`${entityName} deleted successfully`);
      fetchData();
    } catch (e) {
      const msg = e.response?.data?.message || `Failed to delete ${entityName}`;
      toast.error(msg);
      console.error('Delete error:', e.response?.data || e.message);
    }
  };

  const openCreate = () => { setEditItem(null); setModalOpen(true); };
  const openEdit = (item) => { setEditItem(item); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setEditItem(null); };

  return {
    data, total, loading, page, setPage, search, setSearch,
    modalOpen, editItem, saving,
    fetchData, handleSave, handleDelete,
    openCreate, openEdit, closeModal,
  };
}
